import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { RightArrowBigIcon } from '../../icon/icon';
import { formatNumber } from '../../../utils/util';

interface ContractItemProps {
  id: number;
  company: string;
  arrivalDate: string;
  type: number;
  amount: number;
  carType: string;
}
interface ReportDto {
  id: number; // 리포트 ID
  arrivedAt: string; // 도착 날짜
  name: string; // 회사 이름
  dayType: string; // 작업 유형 (반일, 하루 등)
  reportType: string; // 리포트 유형 (belonged 등)
}

interface CompanyReportDto {
  totalAmount: number; // 총 금액
  reports: ReportDto[]; // 리포트 배열
  registClick?: () => void;
  statementClick?: () => void;
}

interface ContractItemsProps {
  items: ContractItemProps[];
  registClick?: () => void;
  statementClick?: () => void;
}

export const DairyItems = ({
  totalAmount,
  reports,
  registClick,
  statementClick,
}: CompanyReportDto) => {
  // const totalAmount = items.reduce((sum, item) => sum + item.amount, 0);

  return (
    <ContractWrap className="inner">
      <div className="total-amount">
        <div className="wrap">
          <span className="title">조회기간 총 수익</span>
          <span className="total-value">
            <span className="won">₩</span>
            <span className="value">{formatNumber(totalAmount)}</span>
          </span>
        </div>
      </div>
      <ul>
        {reports.map((item) => (
          <li key={item.id}>
            <Link
              to={{
                pathname:
                  item.reportType === 'belonged'
                    ? `/userDiary/belonged/detail/${item.id}`
                    : `/userDiary/rent/detail/${item.id}`,
                state: {
                  selectedType: item.reportType,
                },
              }}
            >
              <div className="wrap">
                <div className="t-con">
                  <div className="l-con">
                    <TypeBadge className="type" type={item.dayType}>
                      {item.dayType === 'full' ? '전일' : '반일'}
                    </TypeBadge>
                    <span className="company">{item.name}</span>
                  </div>
                </div>
                <div className="b-con">
                  <div className="l-con">
                    <span className="label">도착날짜</span>
                    <span className="date">{item.arrivedAt}</span>
                  </div>
                  <div className="r-con">
                    <span className="label">종류</span>
                    <span className="date">
                      {item.reportType === 'belonged' ? '일대차' : '마당차'}
                    </span>
                  </div>
                </div>
              </div>
              <div className="icon-box">
                <RightArrowBigIcon />
              </div>
            </Link>
          </li>
        ))}
      </ul>
      <BtnBox>
        <button className="first-btn" onClick={statementClick}>
          거래명세표
        </button>
        <button className="second-btn" onClick={registClick}>
          등록하기
        </button>
      </BtnBox>
    </ContractWrap>
  );
};

// style
const ContractWrap = styled.section`
  background-color: ${(props) => props.theme.textWhiteColor};
  border-radius: 1.6rem;
  overflow: hidden;
  box-shadow: 0 2px 5px 3px rgba(0, 0, 0, 0.05);
  ul {
    display: flex;
    flex-direction: column;
    max-height: 38.4rem;
    height: calc(100vh - 42.4rem);
    overflow-x: hidden;
    overflow: scroll;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    li {
      padding: 1.7rem 1.4rem 1.8rem 2.3rem;
      border-bottom: 1px solid ${(props) => props.theme.gray300};
      a {
        display: flex;
        align-items: center;
        .wrap {
          flex: 1 1 auto;
          display: flex;
          flex-direction: column;
          gap: 0.9rem;
          .t-con {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .l-con {
              display: flex;
              align-items: center;
              gap: 0.8rem;
              .company {
                font-size: 1.8rem;
                font-weight: 600;
                line-height: 2.2rem;
              }
            }
            .r-con {
              display: flex;
              align-items: center;
              gap: 1.1rem;
              .amount {
                font-size: 1.4rem;
                font-weight: 600;
                color: ${(props) => props.theme.btnBlueColor};
                span {
                  font-size: 1.1rem;
                  font-weight: 600;
                  color: ${(props) => props.theme.textAAAColor};
                }
              }
            }
          }
          .b-con {
            display: flex;
            align-items: center;
            gap: 2.4rem;
            .l-con {
              display: flex;
              gap: 1.1rem;
              align-items: center;
              .label {
                font-size: 1.2rem;
                font-weight: 600;
                color: ${(props) => props.theme.textAAAColor};
              }
              .date {
                font-size: 1.3rem;
                font-weight: 600;
              }
            }
            .r-con {
              display: flex;
              gap: 0.8rem;
              align-items: center;
              .label {
                font-size: 1.2rem;
                font-weight: 600;
                color: ${(props) => props.theme.textAAAColor};
              }
              .date {
                font-size: 1.3rem;
                font-weight: 600;
              }
            }
          }
        }
      }
    }
  }
  .total-amount {
    padding: 2.4rem 1.5rem 1.5rem;
    .wrap {
      padding: 1.1rem 1.2rem 1.1rem 1.5rem;
      background-color: ${(props) => props.theme.homeMainBoxBgColor};
      color: ${(props) => props.theme.textWhiteColor};
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-radius: 0.8rem;
      .title {
        font-size: 1.3rem;
        font-weight: 600;
      }
      .total-value {
        display: flex;
        gap: 0.35rem;
        align-items: flex-end;
        .won {
          color: ${(props) => props.theme.workingTypeColor};
          font-size: 1.2rem;
          font-weight: 600;
        }
        .value {
          font-size: 1.6rem;
          font-weight: 600;
        }
      }
    }
  }
`;

const TypeBadge = styled.span<{ type: string }>`
  width: 4.2rem;
  font-size: 1.1rem;
  font-weight: 600;
  border-radius: 1.1rem;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  line-height: 2.2rem;
  background-color: ${(props) =>
    props.type === 'full' ? '#00ffba' : '#FFB400'};
  color: ${(props) => props.theme.textBlackColor};
`;

const BtnBox = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.2rem;
  background-color: ${(props) => props.theme.textWhiteColor};
  padding: 2.4rem 1.5rem 1.2rem;
  button {
    flex: 0 0 50%;
    width: 100%;
    border-radius: 1.2rem;
    border: 0;
    outline: none;
    font-size: 1.8rem;
    font-weight: 600;
    padding: 1.7rem 1rem;
    height: 5.6rem;
  }
  .first-btn {
    background-color: ${(props) => props.theme.textWhiteColor};
    color: ${(props) => props.theme.btnBlueColor};
    border: 1px solid ${(props) => props.theme.btnBlueColor};
  }
  .second-btn {
    background-color: ${(props) => props.theme.btnBlueColor};
    color: ${(props) => props.theme.textWhiteColor};
  }
`;
